import React, {useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from '@mui/material';
import PropTypes from 'prop-types';
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import SoftInput from "../../../components/SoftInput";
import SoftButton from "../../../components/SoftButton";

const AddEditRoomDialog = ({open, onClose, room, isEdit, onSubmit, branch}) => {
    const initialFormState = {
        roomId: '',
        number: '',
        name: '',
        capacity: '',
        ageGroup: '',
        description: '',
        branchId: branch.branchId
    }

    const [formData, setFormData] = useState(initialFormState);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (isEdit && room) {
            setFormData({
                roomId: room.roomId || '',
                number: room.number || '',
                name: room.name || '',
                capacity: room.capacity || '',
                ageGroup: room.ageGroup || '',
                description: room.description || '',
                branchId: branch.branchId || ''
            });
        } else if (open) {
            setFormData(initialFormState);
        }
    }, [isEdit, room, open]);

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEdit ? 'Edit Room' : 'Add Room'}</DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                >
                                    Number
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput
                                name="number"
                                type="number"
                                placeholder=""
                                value={formData.number}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SoftBox mb={0}>
                                <SoftBox mb={1} ml={0.5}>
                                    <SoftTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Name
                                    </SoftTypography>
                                </SoftBox>
                                <SoftInput
                                    name="name"
                                    type="text"
                                    placeholder="Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </SoftBox>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                >
                                    Capacity
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput
                                name="capacity"
                                type="number"
                                placeholder="Capacity"
                                value={formData.capacity}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                >
                                    Age Group
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput
                                name="ageGroup"
                                type="text"
                                placeholder=""
                                value={formData.ageGroup}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                >
                                    Description
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput
                                name="description"
                                type="text"
                                placeholder=""
                                value={formData.description}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    {error && (
                        <div style={{color: "red", marginTop: "10px"}}>
                            {error}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <SoftButton type="submit" variant="contained" color="primary" disable={error}>
                        {isEdit ? "Update Room" : "Add Room"}
                    </SoftButton>
                </DialogActions>
            </form>
        </Dialog>
    );
};

AddEditRoomDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    room: PropTypes.object,
    branch: PropTypes.object,
    isEdit: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
};

export default AddEditRoomDialog;